import { AccountModel, CaseType } from '@onrunning/backstage-models';
import { Feature } from '../models/feature.model';
import { FeaturesService } from '../services/features.service';

const EUROPE = [
  'Andorra',
  'Austria',
  'Belgium',
  'Bulgaria',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Gibraltar',
  'Greece',
  'Hungary',
  'Iceland',
  'Ireland',
  'Israel',
  'Italy',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Monaco',
  'Netherlands',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'Russian Federation',
  'Serbia',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Switzerland',
  'Turkey',
  'Ukraine',
  'United Kingdom',
];

// ToDo this should be move to Features API
export const COUNTRIES_WITH_PAYMENT_OPTION = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'PR', name: 'Puerto Rico' },
];

const feautureService = new FeaturesService();

export const accountMixins = {
  accountCanPayOnline(account: AccountModel): boolean {
    return COUNTRIES_WITH_PAYMENT_OPTION.some(({ name }) => name === account.billingCountry);
  },
  async accountHasCaseCreationEnabled(caseType: CaseType, accountId: string): Promise<boolean> {
    const feature =
      caseType.toLocaleLowerCase() === CaseType.Return.toLocaleLowerCase()
        ? Feature.RETURN_CASES_DISABLED
        : Feature.WARRANTY_CASES_DISABLED;
    const casesDisabled = await feautureService.hasFeature(feature, accountId);

    return !casesDisabled;
  },
  isEuropeanAccount(account: AccountModel): boolean {
    return EUROPE.includes(account.billingCountry);
  },
};
